<template>
  <container :noLeft='true' style='margin-top: 45px;padding-bottom: 35px;'>
    <div class="title fix-box-align-center">
      <img src="/img/bigdata/title-icon.png" alt="" style='margin-right: 12px;'>
      整体出租率
    </div>
    <div class='box-top fix-box-align-center'>
      <img src="/img/bigdata/box-top.png" alt="" class=''>
      <div class="slash">

      </div>
    </div>
    <div class="overallOccupancyRate" style='padding-top: 10px;'>
      <div class='w50 fix-box-align-center'>
        <div class="label">今日</div>
        <div class="value">
          {{detail.todayRentRate |two}}<span>%</span>
        </div>
      </div>
      <div class='w50 fix-box-align-center '>
        <div class="label" >本月</div>
        <div class="value" style='color: #00ED93;'>
          {{detail.monthRentRate |two}}<span>%</span>
        </div>
      </div>

    </div>
    <div class="overallOccupancyRate" style='margin-top: 20px;'>
      <div class='w50 fix-box-align-center'>
        <div class="label">季度</div>
        <div class="value" style='color: #FB8B65;'>
          {{detail.quarterRentRate |two}}<span>%</span>
        </div>
      </div>
      <div class='w50 fix-box-align-center'>
        <div class="label">年度</div>
        <div class="value" style='color: #3578FC;'>
          {{detail.yearRentRate |two}}<span>%</span>
        </div>
      </div>
    </div>
  </container>

</template>

<script>
  import container from "../container";
  import {getRentRate} from "../../../../../api/bigData";

  export default {
    name: "overallOccupancyRate",
    components: {
      container,
    },
    data() {
      return {
        detail:{},
      }
    },
    methods: {
      getRentRate(){
        getRentRate({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.detail=data.content
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {

        })
      },
    },
    created() {
      this.getRentRate()
    },
    filters:{
      two:function (value) {
        if(!value){
          return '0'
        }else{
          return (value*100).toFixed(2)
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .box-top{
    position: absolute;
    left: -1px;
    top: -45px;
    width: 100%;
    .slash{
      width: calc(100% - 216px);
      height: 14px;
      background: url("/img/bigdata/slash-icon.png");
    }
  }
  .title{
    color: #B8D7FF;
    font-size: 16px;
    font-family:Helvetica;
    position: absolute;
    left: 15px;
    top: -30px;
    z-index: 1;
  }
  .overallOccupancyRate {

    padding-left: 7px;
    display: flex;
    align-items: flex-end;
    line-height: 1;
    .label{
      font-size:18px;
      font-family:Helvetica;
      color:rgba(184,215,255,1);
      padding-bottom: 6px;
    }
    .value{
      font-size:36px;
      font-family:Helvetica;
      color:rgba(213,195,1,1);
      margin-left: 15px;
      >span{
        font-size: 26px;
      }
    }
  }
</style>
